import React from 'react';
import Image from '@atlaskit/image';
import Crossflow from './Crossflow.svg';

const CrossflowImage = () => <Image src={Crossflow} alt="Jira Crossflow" />;

export { CrossflowImage };
